module.exports = __webpack_public_path__ + "img/page1.aaf302cd.png";